module.exports = __webpack_public_path__ + "img/img@2x.2a063cab.png";